import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import {
  digiLockerInitiateUrl,
  digiLockerFetchUrl,
  sendBeneficiaryOtpUrl,
  verifyBeneficiaryOtpUrl,
  verifyUserPanUrl,
  beneficiaryNomineeV2Url,
  verifyDigiLockerAccountUrl,
} from '../url';

export const initiateDigiLocker = async (mobileNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        digiLockerInitiateUrl(),
        {
          doc_type: 'AADHAAR',
          mobile_number: mobileNumber,
          sign_up_preference: 'PINLESS',
          check_account_linked: 'false',
          consent: 'Y',
          redirect_url: `${process.env.REACT_APP_BASE_URL}/beneficiary/add-gap-beneficiary`,
        },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const fetchDigiLockerData = async (sessionId) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(digiLockerFetchUrl(sessionId), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const sendBeneficiaryOtp = async (phoneNumber, resend = false) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        sendBeneficiaryOtpUrl(),
        { phone_number: phoneNumber, resend_otp: resend, privacy_policy_accept_status: true },
        getTokenHeader(token),
      )
       .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const verifyUserPan = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(verifyUserPanUrl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const submitBeneficiaryNominee = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(beneficiaryNomineeV2Url(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const verifyDigiLockerAccount = async (mobileNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(verifyDigiLockerAccountUrl(mobileNumber), getTokenHeader(token))
      .then(({ data }) => next(data))
      .catch((err) => next({ error: err }));
  });
};

export const verifyBeneficiaryOtp = async (phoneNumber, otp) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        verifyBeneficiaryOtpUrl(),
        { phone_number: phoneNumber, otp },
        getTokenHeader(token),
      )
     .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
